"use client";
import { getRefreshToken } from "@/Utils/RestClient";
import { getCookie, setCookie } from "cookies-next";
import { useRouter } from "next/navigation";
import React, { useCallback, useEffect } from "react";

const useRefreshToken = () => {
  const router = useRouter();

  const refreshToken = useCallback(
    async (hasAuthenticated: Boolean) => {
      const nanoTime = Number(getCookie("expiresInDot"));
      const timestamp = Number(nanoTime) / 1000000;
      const timeInstance = new Date(timestamp);
      const currentTime = new Date();
      // console.log(currentTime);
      const timeDiff = timeInstance.getTime() - currentTime.getTime();
      const timeDiffInMinutes = Math.floor(timeDiff / (1000 * 60));
      if (hasAuthenticated && nanoTime && timeDiffInMinutes <= 2) {
        try {
          const res = await getRefreshToken();
          const { accessToken, refreshToken, expiresIn } = res?.data;
          setCookie("accessTokenDot", accessToken);
          setCookie("refreshTokenDot", refreshToken);
          setCookie("expiresInDot", expiresIn);
        } catch (error: any) {
          // deleteCookie("accessTokenDot");
          // deleteCookie("app418DotBeta");
          console.log(error);
          // deleteCookie("refreshTokenDot");
          // deleteCookie("expiresInDot");
          // toast.error("Please login");
          // router.push("/login");
        }
      }
    },
    [router]
  );

  return refreshToken;
};

interface AuthChecker {
  hasAuthenticated: Boolean;
}

const TokenRefresher: React.FC<AuthChecker> = ({ hasAuthenticated }) => {
  const refreshToken = useRefreshToken();

  useEffect(() => {
    const interval = setInterval(() => {
      refreshToken(hasAuthenticated);
    }, 60000);

    return () => clearInterval(interval);
  }, [refreshToken, hasAuthenticated]);

  return null;
};

export default TokenRefresher;
